// extracted by mini-css-extract-plugin
export var addButton = "_gn-0";
export var border = "_gn-8";
export var check = "_gn-h";
export var danger = "_gn-6";
export var dropdownContainer = "_gn-1";
export var editModalBody = "_gn-j";
export var footerContainer = "_gn-i";
export var fullWidth = "_gn-a";
export var hide = "_gn-9";
export var icon = "_gn-3";
export var input = "_gn-7";
export var inputFlex = "_gn-b";
export var inputWrapper = "_gn-c";
export var manualFocus = "_gn-5";
export var optionButton = "_gn-4";
export var pillWrapper = "_gn-e";
export var pointer = "_gn-2";
export var showOverflow = "_gn-f";
export var tagsFlex = "_gn-d";
export var xButton = "_gn-g";